<div class="content">
    <h2>What We Believe</h2>
    <div class="cards">
        <div class="card">
            <div class="icon">
                <mat-icon fontSet="material-symbols-outlined" inline>checkroom</mat-icon>
            </div>
            <h4>Effortless Style</h4>
            <p>Pieces that are easy to wear, easy to style, and made for real life.</p>
        </div>
        <div class="card">
            <div class="icon">
                <mat-icon fontSet="material-symbols-outlined" inline>favorite</mat-icon>
            </div>
            <h4>Everyday Confidence</h4>
            <p>Clothing should help you feel natural, comfortable, and beautifully yourself.</p>
        </div>
        <div class="card">
            <div class="icon">
                <mat-icon fontSet="material-symbols-outlined" inline>featured_seasonal_and_gifts</mat-icon>
            </div>
            <h4>Thoughtful Details</h4>
            <p>From fabric and fit to packaging, we care about the small things that shape the full experience.</p>
        </div>
    </div>
</div>